document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.disclosure').forEach(function(disclosure) {
    const button = disclosure.querySelector('.disclosure__button');
    const list = disclosure.querySelector('.disclosure__list-wrapper');

    if (!button || !list) return;

    button.addEventListener('click', function (e) {
      e.preventDefault();
      const isOpen = !list.hasAttribute('hidden');
      // Zapri vse druge disclosure na strani (opcijsko)
      document.querySelectorAll('.disclosure__list-wrapper').forEach(function(el) {
        if (el !== list) el.setAttribute('hidden', '');
      });
      if (isOpen) {
        list.setAttribute('hidden', '');
      } else {
        list.removeAttribute('hidden');
        // Zapri če klikneš izven
        setTimeout(() => {
          document.addEventListener('click', function handler(ev) {
            if (!disclosure.contains(ev.target)) {
              list.setAttribute('hidden', '');
              document.removeEventListener('click', handler);
            }
          });
        }, 0);
      }
    });
  });
});
